export var TrackingUserStatusEnum;
(function (TrackingUserStatusEnum) {
    TrackingUserStatusEnum["LOGGEDIN"] = "loggedin";
    TrackingUserStatusEnum["LOGGEDOUT"] = "loggedout";
})(TrackingUserStatusEnum || (TrackingUserStatusEnum = {}));
//# sourceMappingURL=tracking-user-status.enum.js.map